<aside
  *ngIf="showSidebar$ | async"
  id="main-sidebar"
  class="main-sidebar {{ sidebarSize$ | async }}"
  [@fadeInRightOnEnter]
  [@fadeOutRightOnLeave]
  cdkTrapFocus
  #sidebar
>
  <nibtravel-icon
    class="main-sidebar-close"
    size="lg"
    icon="close"
    (click)="onClose()"
  ></nibtravel-icon>
  <ng-content select="main-sidebar-content"></ng-content>
</aside>
